export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5301.93264ee9.jpg";